import { useSelector } from 'react-redux'

import { useApi } from './ApiProvider'
import { useTimedToggle } from '../utils/hooks/useTimedToggle'
import { useTranslate } from '../utils/translate'

type AvailabilityNotificationFormProps = {
  productId: string
}

export function AvailabilityNotificationForm({ productId }: Readonly<AvailabilityNotificationFormProps>) {
  const [isConfirmationVisible, triggerConfirmation] = useTimedToggle()
  const t = useTranslate('shop', 'components.productComponent.productAvailabilityNotificationForm')
  const csrfToken = useSelector<State, string>((state) => state.getIn(['shop', 'csrfToken']))
  const api = useApi()

  const emailInputId = `availability-email-${productId}`

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const form = event.currentTarget
    const formData = new FormData(form)
    const email = formData.get('email')

    try {
      await api.post(
        `/api/v2/products/${productId}/availability-notifications`,
        {
          email,
        },
        {
          headers: {
            'X-CSRF-Token': csrfToken,
          },
        },
      )
      triggerConfirmation()
      form.reset()
    } catch {
      // Fail silently
    }
  }

  return (
    <form onSubmit={handleSubmit} className="availability-notification-form">
      {isConfirmationVisible ? (
        <div className="notify-notification notify-notification-success">{t('confirmationMessage')}</div>
      ) : null}
      <h4>{t('headline')}</h4>
      <p>{t('description')}</p>
      <label htmlFor={emailInputId}>
        {t('emailField.label')}
        <span aria-hidden="true"> *</span>
      </label>
      <input
        type="email"
        name="email"
        id={emailInputId}
        placeholder={t('emailField.placeholder')}
        required
        aria-required="true"
      />

      <button type="submit">{t('submitButton.label')}</button>
    </form>
  )
}
